<template>
  <div class="background_layer">
    <div class="video_pannel">
      <video id="video" muted autoplay loop playsinline>
        <source src="@/assets/videos/jingraphics.com.home.mp4" type="video/webm">
      </video>
    </div>
    <div class="screen"></div>
    <div v-if="loader && !loaded" class="loader">
      <div class="lds-dual-ring"><div></div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'background',
  props: {
    loader: {
      type: Boolean,
      default: () => false
    },
  },
  data: () => ({
    video: {
      w: 1920,
      h: 1080,
      r: 0.5625
    },
    loaded: false,
  }),
  mounted() {
    window.addEventListener('resize', this.resize, false)
    if(window.iOS || window.safari) document.getElementById('video').addEventListener('loadstart', this.load, true)
    else document.getElementById('video').addEventListener('loadedmetadata', this.load, false)
  },
  methods: {
    load() {
      if(window.iOS || window.safari) {
        document.getElementById('video').removeEventListener('loadstart', this.load, true)
      }

      this.resize()
      this.setBackgroundOpacity(true).then(() => {
        this.loaded = true
        this.$emit('loaded')
      })
    },
    resize() {
      let v = document.getElementById("video")
      let w = window.outerWidth
      let h = window.outerHeight
      let r = h / w

      // reset video size
      if(r < this.video.r) {
        v.style.width = '100%'
        v.style.height = 'auto'
      } else {
        v.style.width = 'auto'
        v.style.height = '100%'
      }
    },
    setBackgroundOpacity() {
      this.$anime({
        targets: '.background_layer .screen',
        opacity: [1, .925],
        easing: "easeOutExpo",
        duration: 500,
        delay: 500,
      })

      return new Promise(resolve => {
        setTimeout(() => { resolve(true) }, 500)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.background_layer {
  position:fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;

  .video_pannel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .screen {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: #5da6c9;
    opacity: 1;
  }

  .loader {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .lds-dual-ring {
      display: inline-block;
      width: 80px;
      height: 80px;
    }
    .lds-dual-ring:after {
      content: " ";
      display: block;
      width: 64px;
      height: 64px;
      margin: 8px;
      border-radius: 50%;
      border: 6px solid #fff;
      border-color: #fff transparent #fff transparent;
      animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>